import styled, { css } from "styled-components";
import { colors } from "../colors/color";
import { SmallStyling } from "../styles/typography";
import { assertNever } from "../../amorg-common";
import React from "react";

export type bodyColors = 'neutral' | 'default' | 'white' | 'error';

export const handlebodyColor = (color?: bodyColors) => {
    switch (color) {
        case "neutral":
            return `${colors.text.gray.dark}`;
        case "default":
            return `${colors.text.gray.dark}`;
        case "white":
            return `white`;
        case "error":
            return `${colors.text.state.error}`;
        default:
            return `${colors.text.gray.dark}`;
    }
};



export const bodyShared = css`
    font-family: 'Noto Sans', sans-serif;
    font-size:16px;
    font-weight: 300;
    letter-spacing: 0.5px;
    line-height: 1.4;
    color: ${colors.text.gray.dark};
`;

export const P = styled.p<{ color?:bodyColors, verticalMargin?:string, fontSize?:string, paddingTop?:boolean }>`
    ${bodyShared}
    
    margin-top: ${props => props.verticalMargin || '0px'};
    margin-bottom: ${props => props.verticalMargin || '0px'};
    color: ${({ color }) => handlebodyColor(color)}; 
    font-size:${props => props.fontSize || '16px'};
    ${props => props.paddingTop && 'padding-top: 10px'};
    ${props => props.fontSize && `font-size: ${props.fontSize};`}
`;

export const Strong = styled.strong<{color?:bodyColors}>`
    font-size: 16px;
    font-weight: 600;
`;

export const Small = styled.small<{color?:bodyColors, variant?:'neutral'|'normal'}>`
    ${SmallStyling}
`;

export type SpanProps = React.PropsWithChildren<{
    size?:string,
    margin?:string,
    bold?:boolean,
    fontWeight?:number,
    textDecoration?: 'underline' | 'line-through' | 'none',
    italic?:boolean,
    textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'none',
    color?: 'normal' | 'gray' | 'light-gray' | 'disabled' | 'active' | 'white',
    style?:React.CSSProperties
}>

export function Span(props:SpanProps):JSX.Element
{
    let color = '';
    if(props.color === undefined) {
        color = colors.text.normal;
    }
    else if(props.color === 'normal') {
        color = colors.text.normal;
    }
    else if(props.color === 'gray') {
        color = colors.text.gray.normal;
    }
    else if(props.color === 'light-gray') {
        color = colors.text.gray.light;
    }
    else if(props.color === 'disabled') {
        color = colors.text.muted;
    }
    else if(props.color === 'active') {
        color = colors.text.active;
    }
    else if(props.color === 'white') {
        color = colors.text.white;
    }
    else {
        assertNever(props.color);
    }


    return (
        <span style={{
                fontSize: props.size || '16px',
                margin: props.margin,
                fontWeight: props.bold 
                    ? 600 
                    : props.fontWeight,
                color: color,
                textDecoration: props.textDecoration,
                fontStyle: props.italic ? 'italic' : 'normal',
                textTransform: props.textTransform || 'none',
                ...props.style
            }}>
            
            {props.children}

        </span>
    );
};

export const Span12 = (props:SpanProps) => <Span {...props} size="12px" />;
export const Span14 = (props:SpanProps) => <Span {...props} size="14px" />;
export const Span16 = (props:SpanProps) => <Span {...props} size="16px" />;